import '../../components/ask-ai-button';

import {
  ActionPlacement,
  type ToolbarModuleConfig,
} from '@blocksuite/affine/shared/services';
import { html } from 'lit';

export function toolbarAIEntryConfig(): ToolbarModuleConfig {
  return {
    actions: [
      {
        placement: ActionPlacement.Start,
        id: 'A.ai',
        score: -1,
        when: ({ flags }) => !flags.isNative(),
        content: ({ host }) => html`
          <ask-ai-toolbar-button .host=${host}></ask-ai-toolbar-button>
        `,
      },
    ],
  };
}
